import { find, get, isEmpty } from 'lodash-es';

import * as moment from 'moment';
import { Features } from '../../../../../../../../../frontend/libs/shared/src/lib/types/features';

class RfiResponseCtrl {
  questions: any[];

  responses: any[];

  sellers: any[];

  unspscs: any[];

  sellerUnspscParticipation: any[];

  featureList: Features

  constructor(public $scope, private api, public $sce) {
    'ngInject';
  }

  // TODO: Use $onChanges to make a copy of the non-primitive bindings being passed in here
  // This will ensure that we never modify the original object from within this component

  getRfiQuestions() {
    return this.questions;
  }

  getRfiResponses() {
    return this.responses;
  }

  getSellerList() {
    return this.sellers;
  }

  getUnspscsList() {
    return this.unspscs;
  }

  getSellerUnspscParticipation(sellerId, unspscId) {
    var sellerUnspsc =
      find(this.sellerUnspscParticipation, {
        sellerId: sellerId,
        unspscsId: unspscId
      }) || {};

    return sellerUnspsc.participate;
  }

  getRFIResponseBySellerId(sellerId, questionId) {
    var responses = this.getRfiResponses() || [];

    var response = find(responses, { sellerId: sellerId });

    if (!isEmpty(response)) {
      return find(response.answers, { questionId: questionId });
    } else {
      return {};
    }
  }

  getTextForNonMultiChoiceResponse(sellerResponse) {
    let answerType = get(sellerResponse, 'kind');
    let dateDisplayFormat = 'MM/DD/YYYY';

    switch (answerType) {
      case 'DateRangeQuestion':
        let dateRange = '';

        if (!isEmpty(sellerResponse.dateRangeAnswer)) {
          let fromDate = moment(sellerResponse.dateRangeAnswer.fromDate).format(
            dateDisplayFormat
          );
          let toDate = moment(sellerResponse.dateRangeAnswer.toDate).format(
            dateDisplayFormat
          );

          dateRange = `From ${fromDate} to ${toDate}`;
        } else {
          dateRange = '';
        }

        return dateRange;

      // break; // -- the break is implicit due to the return

      case 'DateQuestion':
        return sellerResponse.singleDateAnswer
          ? moment(sellerResponse.singleDateAnswer).format(dateDisplayFormat)
          : '';

      // break; // -- the break is implicit due to the return

      case 'NumericQuestion':
        return sellerResponse.numericaAnswer;
      // break; -- the break is implicit due to the return

      // legacy page simply displayed the single value for scale so doing same here
      case 'ScaleQuestion':
        return sellerResponse.scaleAnswer;
      // break; -- the break is implicit due to the return

      case 'TextQuestion':
        return sellerResponse.textAnswer;
      // break; -- the break is implicit due to the return

      default:
        throw new Error(`Answer type not resolved - type is: ${answerType}`);
    }
  }

  getQuestionChoiceAnswer(choiceId, choiceAnswers) {
    var answer = find(choiceAnswers, { id: choiceId }) || {};

    return (answer as any).selected;
  }

  getWordingForSelectedAnswer(sellerAnswers, questionChoices) {
    var answer = find(sellerAnswers, { selected: true }) || {};
    // var questions = this.getRfiQuestions();

    if (!isEmpty(answer)) {
      var choice = find(questionChoices, { id: (answer as any).id }) || {};

      return (choice as any).choiceWording;
    }
  }
}

export const RfiResponsesComponent = {
  controller: RfiResponseCtrl,
  template: require('./rfiResponses.html'),
  bindings: {
    responses: '<',
    questions: '<',
    sellers: '<',
    unspscs: '<',
    sellerUnspscParticipation: '<',
    featureList: '<'
  }
};
